// Inline crypto brand SVG icons (no external CDN dependency).
// Pure React components — can be styled via className/size.

export const UsdtIcon = ({ size = 40, className = "" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} className={className} aria-label="USDT">
    <circle cx="16" cy="16" r="16" fill="#26A17B" />
    <path
      d="M17.92 17.383v-.002c-.11.008-.68.042-1.947.042-1.011 0-1.723-.03-1.973-.042v.003c-3.886-.171-6.786-.848-6.786-1.657s2.9-1.485 6.786-1.659V16.7c.254.018.983.061 1.99.061 1.207 0 1.816-.05 1.93-.06v-2.634c3.878.173 6.77.85 6.77 1.657 0 .81-2.893 1.485-6.77 1.657m0-3.59V11.41h4.87V8.16H9.235v3.25h4.866v2.38c-3.955.182-6.931 1.063-6.931 2.118 0 1.055 2.976 1.935 6.93 2.118v7.62h3.823v-7.621c3.947-.184 6.917-1.063 6.917-2.117 0-1.054-2.969-1.933-6.917-2.117"
      fill="#fff"
    />
  </svg>
);

export const TronIcon = ({ size = 20, className = "" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} className={className} aria-label="TRON">
    <circle cx="16" cy="16" r="16" fill="#EF0027" />
    <path
      d="M22.01 10.207c-.418-.388-.997-.98-1.47-1.406l-.028-.02a.774.774 0 0 0-.302-.164h-.001c-1.136-.212-6.418-1.2-6.521-1.187a.324.324 0 0 0-.133.043l-.027.021a.431.431 0 0 0-.103.165l-.008.02v.113l.003.017 1.227 3.418L8.573 10c-.075-.01-.244-.031-.262-.028-.059.01-.112.042-.146.093l-.016.02c-.032.056-.068.172-.073.2l-.004.022v.039l.003.06 2.954 8.326c.118.375.344.724.674 1.007.33.28 4.925 3.79 5.344 4.117.02.015.18.14.226.136.067-.005.11-.065.144-.105l.014-.016c.093-.128 4.978-6.047 5.223-6.371.036-.048.197-.247.206-.351a.578.578 0 0 0-.097-.356l-.044-.06L22.01 10.207zm-3.38 1.288-.69.566a.53.53 0 0 1-.203.088l-.046.005a.502.502 0 0 1-.186-.034l-.021-.009a.52.52 0 0 1-.165-.126l-2.18-2.47 4.014 2.001-.523-.021zm.88.732 1.725-1.377-.355 2.213-1.37-.836zm-.492.21-3.004 2.451c-.047.038-.121.096-.19.138l-.024.015a.625.625 0 0 1-.183.074l-.024.004a.574.574 0 0 1-.186-.005l-.023-.005-3.11-.62 6.744-2.052zm-8.242-1.04 6.032 1.125-7.044 2.137 1.012-3.262zm-.32 3.954 3.31.664a.56.56 0 0 1 .244.108l.017.013a.555.555 0 0 1 .15.17l.01.018 2.116 3.94-5.847-4.913zm6.31 5.308-2.175-4.05a.547.547 0 0 1 .12-.681l.02-.016a.63.63 0 0 1 .216-.12l3.38-.923-1.56 5.79zm2.153-6.034 1.49.91-3.475 2.842 1.985-3.752zm2.095-.228-.435 2.713L19 16.328l1.913-1.56.002-.001z"
      fill="#fff"
    />
  </svg>
);

export const BnbIcon = ({ size = 20, className = "" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} className={className} aria-label="BNB">
    <circle cx="16" cy="16" r="16" fill="#F3BA2F" />
    <path
      d="M12.116 14.404 16 10.52l3.886 3.886 2.26-2.26L16 6l-6.144 6.144 2.26 2.26zM6 16l2.26-2.26L10.52 16l-2.26 2.26L6 16zm6.116 1.596L16 21.48l3.886-3.886 2.26 2.259L16 26l-6.144-6.144-.003-.003 2.263-2.257zM21.48 16l2.26-2.26L26 16l-2.26 2.26L21.48 16zm-3.188-.002h.002V16L16 18.294l-2.291-2.29-.004-.004.004-.003.401-.402.195-.195L16 13.706l2.293 2.293z"
      fill="#fff"
    />
  </svg>
);

export const EthIcon = ({ size = 20, className = "" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} className={className} aria-label="Ethereum">
    <circle cx="16" cy="16" r="16" fill="#627EEA" />
    <g fill="#fff" fillRule="nonzero">
      <path fillOpacity=".602" d="M16.498 4v8.87l7.497 3.35z" />
      <path d="M16.498 4 9 16.22l7.498-3.35z" />
      <path fillOpacity=".602" d="M16.498 21.968v6.027L24 17.616z" />
      <path d="M16.498 27.995v-6.028L9 17.616z" />
      <path fillOpacity=".2" d="m16.498 20.573 7.497-4.353-7.497-3.348z" />
      <path fillOpacity=".602" d="m9 16.22 7.498 4.353v-7.701z" />
    </g>
  </svg>
);
